import React, { useState } from "react";

const TaskTable = ({ tasks = [], activities = [], onEdit, onDelete }) => {
  const [selectedActivityId, setSelectedActivityId] = useState("");

  // Filter tasks by selected activity
  const filteredTasks = selectedActivityId
    ? tasks.filter((task) => task.activityId === selectedActivityId)
    : tasks;

  return (
    <div className="mt-6">
      {/* Activity Filter Dropdown */}
      <div className="mb-4">
        <label className="block text-sm font-medium mb-1">Filter by Activity:</label>
        <select
          className="border px-3 py-2 rounded w-full max-w-xs"
          value={selectedActivityId}
          onChange={(e) => setSelectedActivityId(e.target.value)}
        >
          <option value="">All Activities</option>
          {activities.map((activity) => (
            <option key={activity._id} value={activity._id}>
              {activity.title}
            </option>
          ))}
        </select>
      </div>

      {/* Task Table */}
      {filteredTasks.length === 0 ? (
        <p className="text-gray-500">No tasks found for this activity.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border text-sm text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border">Task Title</th>
                <th className="px-4 py-2 border">Assigned To</th>
                <th className="px-4 py-2 border">Status</th>
                <th className="px-4 py-2 border">Progress</th>
                <th className="px-4 py-2 border text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredTasks.map((task) => (
                <tr key={task._id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border">{task.title}</td>
                  <td className="px-4 py-2 border">{task.assignedTo?.name || "N/A"}</td>
                  <td className="px-4 py-2 border">{task.status}</td>
                  <td className="px-4 py-2 border">{task.progress}%</td>
                  <td className="px-4 py-2 border text-center">
                    <button
                      onClick={() => onEdit(task)}
                      className="text-blue-600 hover:underline mr-3"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => onDelete(task._id)}
                      className="text-red-600 hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TaskTable;
